import React from 'react';
import { Link } from 'react-router-dom';
export function About() {
  return <div className="max-w-2xl mx-auto px-6 pt-32 pb-24 text-center" data-id="element-2546">
      <h1 className="text-4xl font-bold text-white mb-16 font-title" data-id="element-2547">
        About Us
      </h1>

      <div className="flex flex-col items-center justify-center space-y-6" data-id="element-2548">
        <div className="w-32 h-32 rounded-full bg-neutral-800 border-4 border-neutral-900 overflow-hidden shadow-2xl" data-id="element-2549">
          {/* Placeholder for Tony's photo */}
          <div className="w-full h-full bg-gradient-to-br from-neutral-700 to-neutral-900 flex items-center justify-center" data-id="element-2550">
            <span className="text-4xl" data-id="element-2551">👋</span>
          </div>
        </div>

        <div className="space-y-2" data-id="element-2552">
          <h2 className="text-2xl font-bold text-white" data-id="element-2553">Tony</h2>
          <p className="text-neutral-400 font-body text-lg" data-id="element-2554">
            Y Combinator S21 • Product Builder
          </p>
        </div>

        <a href="https://twitter.com/gigabrain" target="_blank" rel="noopener noreferrer" className="text-blue-400 hover:text-blue-300 transition-colors font-medium" data-id="element-2555">
          @gigabrain
        </a>
      </div>

      <div className="mt-24 pt-12 border-t border-neutral-800/50" data-id="element-2556">
        <Link to="/contact" className="text-2xl font-bold text-white hover:text-neutral-300 transition-colors inline-flex items-center gap-2 group" data-id="element-2557">
          Join the team?
          <span className="text-neutral-500 group-hover:translate-x-1 transition-transform" data-id="element-2558">
            →
          </span>
        </Link>
      </div>
    </div>;
}